// @flow
import  {
	forwardRef,
	useImperativeHandle,
	useState,
} from 'react';
import AdapterJalali from '@date-io/date-fns-jalali';
import { LocalizationProvider, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

// todo add type flow
// $FlowFixMe
export default forwardRef((props, ref): React$Node => {
	const [date, setDate] = useState(null);
	const [mask] = useState('____/__/__');


	const onDateChanged = (selectedDates) => {
		setDate(selectedDates);
		// eslint-disable-next-line react/prop-types
		props.onDateChanged();
	};


	useImperativeHandle(ref, () => ({
		getDate() {
			return date;
		},

		setDate(newDate) {
			setDate(newDate);
		},
	}));

	return (
		<div
			className={'ag-input-wrapper'}
			role={'presentation'}
		>
			<LocalizationProvider dateAdapter={AdapterJalali} dateFormats={{ monthShort: 'MMMM' }}>
				<MuiDatePicker
					mask={mask}
					value={date}
					views={['year', 'month', 'day']}
					onChange={(newValue) => {
						onDateChanged(newValue);
					}}
					renderInput={(params) => {
						// eslint-disable-next-line no-param-reassign
						params.inputProps.placeholder = mask;
						return <TextField
							sx={{
								width: '100%',
								height:'46.188px',
								mt: 1,
								'.MuiInputBase-input': {
									direction: 'rtl',
									textAlign: 'left',
								},
							}}
							{...params}
						/>
					}}
				/>
			</LocalizationProvider>
		</div>
	);
});
